import { render, staticRenderFns } from "./MaterialStock.vue?vue&type=template&id=4087d18e&scoped=true"
import script from "./MaterialStock.vue?vue&type=script&lang=js"
export * from "./MaterialStock.vue?vue&type=script&lang=js"
import style0 from "./MaterialStock.vue?vue&type=style&index=0&id=4087d18e&scoped=true&lang=css"
import style1 from "./MaterialStock.vue?vue&type=style&index=1&id=4087d18e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087d18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4087d18e')) {
      api.createRecord('4087d18e', component.options)
    } else {
      api.reload('4087d18e', component.options)
    }
    module.hot.accept("./MaterialStock.vue?vue&type=template&id=4087d18e&scoped=true", function () {
      api.rerender('4087d18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/MaterialStock.vue"
export default component.exports